module.exports = "https://cdn-skillquest.mathletics.com/app/186/assets/images/85b6ffb9db10c2fdfa0dd2e239606cce.svg";